import React, { useRef, useEffect, FC, LegacyRef } from 'react'
import SignaturePad, { ReactSignatureCanvasProps } from 'react-signature-canvas'
import { Checkbox } from 'antd'
import FormStateType from '../../FormState.type'
import { colors } from '@lmc/common/constants'

function useInterval(
  callback: (() => void) | undefined,
  delay: number | null | undefined
) {
  const savedCallback = useRef<unknown>()

  useEffect(() => {
    savedCallback.current = callback
  }, [callback])

  useEffect(() => {
    function tick() {
      // @ts-ignore
      if (savedCallback.current) savedCallback.current()
    }
    if (delay !== null) {
      const id = setInterval(tick, delay)
      return () => clearInterval(id)
    }
    return undefined
  }, [delay])
}

type Props = {
  setFormState: (newState: object) => void
  formState: FormStateType
  confirmText: string
}

type CanvasProps = {
  clear?: () => void
  isEmpty?: () => boolean
  getTrimmedCanvas?: () => { toDataURL: (input: string) => void }
} & ReactSignatureCanvasProps

export const SignatureForm: FC<Props> = ({
  setFormState,
  formState,
  confirmText
}) => {
  const sigCanvas = useRef<CanvasProps>({})
  const { hasConfirmed, imageURL } = formState

  useInterval(() => {
    const isEmpty = sigCanvas?.current?.isEmpty?.()
    if (!isEmpty) saveImage()
  }, 500)

  const clear = () => {
    // eslint-disable-next-line no-unused-expressions
    sigCanvas &&
      sigCanvas.current &&
      sigCanvas.current?.clear &&
      sigCanvas.current?.clear()
    setFormState({ imageURL: null })
  }

  const saveImage = () => {
    const newImageUrl = sigCanvas?.current
      ?.getTrimmedCanvas?.()
      .toDataURL?.('image/png')
    if (newImageUrl !== imageURL) {
      setFormState({ imageURL: newImageUrl })
    }
  }

  return (
    <div className="signature-modal-vertial-center">
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginTop: 12,
          marginBottom: 5
        }}
      >
        <div style={{ fontWeight: 'bold', fontSize: 16 }}>
          Draw Signature Here
        </div>
        <div
          onClick={clear}
          data-testid="signature-clear-btn"
          style={{ cursor: 'pointer', color: colors.primary }}
        >
          Clear
        </div>
      </div>
      <SignaturePad
        ref={sigCanvas as LegacyRef<SignaturePad> | undefined}
        canvasProps={
          {
            className: 'signatureCanvas',
            'data-testid': 'signature-canvas'
          } as React.CanvasHTMLAttributes<HTMLCanvasElement>
        }
        backgroundColor="rgb(245, 244, 247)"
      />
      <div style={{ margin: '8px 0 10px' }}>
        <Checkbox
          checked={hasConfirmed}
          data-testid="signature-confirm-checkbox"
          onClick={() => {
            setFormState({ hasConfirmed: !hasConfirmed })
          }}
        >
          {confirmText}
        </Checkbox>
      </div>
    </div>
  )
}

export default SignatureForm
